class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");

      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  cartUpdateUnsubscriber = undefined;
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      },
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
    );
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0,
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector,
            ) || "";
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue,
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`),
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name"),
          );
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });

        // Step 1: Collect total engraving quantity across all lines
        const totalEngravingQty = parsedState.items.reduce((sum, item) => {
          if (item.properties?.engraving === 'true') {
            return sum + item.quantity;
          }
          return sum;
        }, 0);
        const ENGRAVING_VARIANT_ID = 55890115625347;
        
        // Step 2: Find engraving line index
        const engravingIndex = parsedState.items.findIndex(item => item.variant_id === ENGRAVING_VARIANT_ID);
        const engravingLine = engravingIndex !== -1 ? engravingIndex + 1 : null;
        
        // Step 3: Sync
        if (totalEngravingQty > 0) {
          if (engravingLine) {
            const existingQty = parsedState.items[engravingLine - 1]?.quantity;
            if (existingQty !== totalEngravingQty) {
              this.syncEngravingLine(engravingLine, totalEngravingQty);
            }
          } else {
            this.addEngravingLine(totalEngravingQty);
          }
        } else if (engravingLine) {
          this.syncEngravingLine(engravingLine, 0);
        }

        
      })
      // .catch(() => {
      //   this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      //   const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      //   errors.textContent = window.cartStrings.error;
      // })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  syncEngravingLine(lineNumber, qty) {
    console.log("SYNC engraving");
    const body = JSON.stringify({
      line: lineNumber,
      quantity: qty,
      sections: this.getSectionsToRender().map(s => s.section),
      sections_url: window.location.pathname
    });
    return fetch(routes.cart_change_url, { ...fetchConfig(), body })
      .then(res => res.json())
      .then(parsed => {
        // Fetch updated cart sections manually
        fetch(`${routes.cart_url}?sections=main-cart-items,cart-drawer,cart-icon-bubble`)
        .then(res => res.json())
        .then(sections => {

          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: sections });
          // Update cart drawer
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer && cartDrawer.hasAttribute("open")) {
            cartDrawer.renderContents({ sections }, false);
          }
          // Update cart page
          const container = document.getElementById('main-cart-items');
          const cartItemsSectionHTML = sections['main-cart-items'];
          if (container && cartItemsSectionHTML) {
            const el = container.querySelector('.js-contents');
            if (el) el.innerHTML = cartItemsSectionHTML;
          }
          // Update cart bubble
          const cartBubble = document.getElementById('cart-icon-bubble');
          if (cartBubble && sections['cart-icon-bubble']) {
            cartBubble.innerHTML = sections['cart-icon-bubble'];
          }

        });
      });
  }
  
  addEngravingLine(qty) {
    console.log("ADD engraving")
    const engravingForm = new FormData();
    engravingForm.append('id', '55890115625347');
    engravingForm.append('quantity', qty.toString());
    return fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: engravingForm
    })
    .then(res => res.json())
    .then(parsed => {
        // Fetch updated cart sections manually
        fetch(`${routes.cart_url}?sections=main-cart-items,cart-drawer,cart-icon-bubble`)
        .then(res => res.json())
        .then(sections => {

          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: sections });
          // Update cart drawer
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer && cartDrawer.hasAttribute("open")) {
            cartDrawer.renderContents({ sections }, false);
          }
          // Update cart page
          const container = document.getElementById('main-cart-items');
          const cartItemsSectionHTML = sections['main-cart-items'];
          if (container && cartItemsSectionHTML) {
            const el = container.querySelector('.js-contents');
            if (el) el.innerHTML = cartItemsSectionHTML;
          }
          // Update cart bubble
          const cartBubble = document.getElementById('cart-icon-bubble');
          if (cartBubble && sections['cart-icon-bubble']) {
            cartBubble.innerHTML = sections['cart-icon-bubble'];
          }

        });
    });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      if (message.length > 0) lineItemError.style.display = "flex";
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;
    }

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      ?.querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`,
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`,
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden"),
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`,
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`,
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden"),
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({
              note: document.querySelector('[data-id="wt-cart-note"]').value,
            });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER),
        );
      }
    },
  );
}
